import VendorProfileForm from "components/VendorProfile/VendorProfileForm";
import { useAppMeta } from "hooks";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  useGetVendorProfileDetailQuery,
  useUpdateVendorProfileMutation,
} from "store/services/vendorProfileApi";

const VendorProfileEditScreen = () => {
  let { id } = useParams();

  let navigate = useNavigate();

  const breadcrumbs = [
    {
      title: "Vendor-Profile",
      path: "/app/crm/vendor-profile/list",
    },
    {
      title: "Edit Vendor Profile",
    },
  ];

  // RTK Query
  const { data: vendorProfileDetail, isLoading: loadingVendorProfileDetail } =
    useGetVendorProfileDetailQuery(id);

  const [updateVendorProfile, { isLoading: updatingVendorProfile }] =
    useUpdateVendorProfileMutation();

  // method
  const handleVendorUpdate = async (data) => {
    try {
      await updateVendorProfile(data).unwrap();
      navigate(`/app/crm/vendor-profile/${id}/detail`);
      toast.success("Vendor Profile successfully updated!");
    } catch (error) {
      toast.error(
        error?.data?.message ??
          error?.message ??
          "Couldn't update vendor Profile!"
      );
    }
  };

  useAppMeta("Edit Vendor Profile");

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingVendorProfileDetail || updatingVendorProfile}
    >
      <BreadcrumbLayout.Paper>
        <VendorProfileForm
          vendorProfileDetail={vendorProfileDetail}
          isBusy={loadingVendorProfileDetail || updatingVendorProfile}
          onSubmit={handleVendorUpdate}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default VendorProfileEditScreen;
